/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { HamburgerCloseIcon } from './hamburgerCloseIcon';
import { NavbarLinkList } from './navbarLinkList';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';
import { SettingsButton } from '../settingsPopup/settingsButton';
import { weatherBugAdsForAdvertisersRoute } from '../../common/utilities/routeHelper';
import { translate } from '../../../common/translation/translate';

export const HamburgerNav = withScreenSize(memo(({ onClose, isMobile }) => {
    return (
        <Container>
            <TopContainer>
                <CloseIconContainer onClick={onClose}>
                    <HamburgerCloseIcon />
                </CloseIconContainer>
            </TopContainer>
            <BottomContainer>
                <NavbarLinkList isHamburgerView={true} />
                <SettingsButton uppercase={true} />
            </BottomContainer>
            { isMobile && <BrandContainer>
                <CorporateLink href='https://www.groundtruth.com/'>GroundTruth</CorporateLink>
                <CorporateLink href={weatherBugAdsForAdvertisersRoute} target='_blank'>{translate('weatherBugAdsForAdvertisers')}</CorporateLink>
            </BrandContainer>
            }
        </Container>
    );
}));

HamburgerNav.propTypes = {
    onClose: PropTypes.func.isRequired,
    isMobile: PropTypes.bool
};

const containerKeyframes = keyframes`
  0% {
    width: 0px;
  }
  100% {
    width: 100%;
  }
`;

const Container = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(47,111,140,0.95);
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: auto;

    animation-name: ${containerKeyframes};
    animation-duration: 0.25s;
    animation-timing-function: ease-in-out;
    animation-delay: 0s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
`;

const TopContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
`;

const BottomContainer = styled.div`
  overflow: auto;
  height: calc(100% - 160px);
  width: 100%;
`;

const CloseIconContainer = styled.div`
    border-radius: 100%;
    width: 40px;
    height: 40px;
    border: 2px solid rgba(255,255,255,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const BrandContainer = styled.div`
    height: 60px;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 0;
    text-align: center;
`;

const BrandLink = styled.a`
    color: #FFFFFF;
    text-decoration: none;
    font-family: Source Sans Pro;
    font-size: 16px;
    font-weight: 600;
    line-height: 20.11px;
    text-align: left;
`;

const CorporateLink = styled(BrandLink)`
    &::after {
        content: ' • ';
        color: #FFFFFF;
        margin: 0 7px;
    }

    &:last-of-type::after {
        content: '';
    }
`;